import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import LevendeStillbilde from '@nrk/dh-basis-levende-stillbilde'
import Bildesveip from './components/bildesveip.js'
import Wrapper from './components/wrapper.js'
import './client.css'
import './components/bildesveip.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

function safeDefine(elementName, constructor) {
  if (typeof customElements.get(elementName) === 'undefined') {
    customElements.define(elementName, constructor)
  }
}

export class AppElement extends HTMLElement {
  name = tag
  #observer

  connectedCallback() {
    this.#defineCustomElements()

    // Log views
    // eslint-disable-next-line compat/compat
    this.#observer = new IntersectionObserver(
      (intersections) => {
        if (intersections[0]?.isIntersecting) {
          // TODO: Log view
          this.#observer.disconnect()
        }
      },
      { threshold: [0.99] },
    )
    this.#observer.observe(this)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.#observer?.disconnect()
  }

  async #defineCustomElements() {
    safeDefine('dh-bildesveip', Bildesveip)
    safeDefine('dh-bildesveip-wrapper', Wrapper)
    safeDefine('dh-bs-levende-stillbilde', LevendeStillbilde)

    if (this.features.kart && typeof customElements.get('dhbs-basis-kart') === 'undefined') {
      const BasisKart = (await import('./kart.js' /* webpackChunkName: "dh-basis-kart" */)).default
      safeDefine('dh-bs-kart', BasisKart)
    }

    this.addEventListener('dh-basis-sveip-active-changed', (e) => {
      e.preventDefault()
      // TODO: log progress
      // this.sendGaEvent({ eventAction: 'ACTIVE-CHANGED', eventLabel: e.detail.nextIndex })
    })
  }

  get features() {
    return JSON.parse(this.getAttribute('features'))
  }
}

safeDefine(tag, AppElement)
